import { useState } from 'react';
import './StarRating.css';
import star_full from './components/star_full.png';
import star_half from './components/star_half.png';
import star_null from './components/star_null.png';

const StarRating = ({ max = 5, step = 0.5, value = 0, onChange }) => {
  // const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(null);

  const getStarImage = (i) => {
    const starIndex = i + 1;  // 별의 위치
    const current = hover ?? value; // 진짜 점수
    
    if (current >= starIndex) return star_full;
    if (current >= starIndex - 0.5 && step === 0.5) return star_half;
    return star_null;
  };

  const handleClick = (e, i) => {
    const rect = e.target.getBoundingClientRect();
    const offsetX = e.clientX - rect.left;
    const half = offsetX < rect.width / 2;

    const newRating = step === 1 ? i + 1 : half ? i + 0.5 : i + 1;
    onChange?.(newRating);
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {Array.from({ length: max }).map((_, i) => (
        <img
          key={i}
          src={getStarImage(i)}
          alt={`${i + 1}점`}
          style={{ width: '50px', height: '50px', cursor: 'pointer' }}
          onMouseMove={(e) => {
            const rect = e.currentTarget.getBoundingClientRect();
            const offsetX = e.clientX - rect.left;
            const hoverValue = step === 1
              ? i + 1
              : offsetX < rect.width / 2 ? i + 0.5 : i + 1;
            setHover(hoverValue);
          }}
          onMouseLeave={() => setHover(null)}
          onClick={(e) => handleClick(e, i)}
        />
      ))}
      <div style={{ marginLeft: '8px' }}>{Number(hover ?? value).toFixed(1)}점</div>
    </div>
  );
};
export default StarRating;
